import React from 'react';
import { Trans } from '@lingui/macro';
import EmptyState from 'components/EmptyState';
import { useSearchModifiers } from 'controllers/SearchController/hooks/useSearchModifiers';
import { UpsellBanner } from 'components/DetailsView/components/UpsellBanner';

export const DefaultEmptyState: React.FC = () => {
    const { clearAll } = useSearchModifiers();

    const handleOnClick = () => {
        clearAll();
    };

    return (
        <>
            <UpsellBanner />
            <EmptyState>
                <EmptyState.Title>
                    <Trans>
                        Oops, looks like there were no results to match your
                        search.
                    </Trans>
                </EmptyState.Title>
                <EmptyState.Content>
                    <Trans>
                        Try using fewer filters for a wider range of results.
                    </Trans>
                </EmptyState.Content>
                <EmptyState.Cta onClick={handleOnClick}>
                    <Trans>Clear filters</Trans>
                </EmptyState.Cta>
            </EmptyState>
        </>
    );
};
